import StdButton from "../../components/StdButton";
import { colorsList } from "../../data/colorsList";
import { eventsRows } from "../../data/eventsData";
import { strLang } from "../../functions/strLang";
import DeleteIcon from "@mui/icons-material/Delete";

export default function EventsList({ data, updateCategory, addAddressModal }) {
  return (
    <div style={{ backgroundColor: "white", width: "100%", marginTop: 20 }}>
      <table cellSpacing={1} style={{ width: "100%" }}>
        <tbody>
          {eventsRows.map((e, index) => (
            <tr key={index}>
              {e.map(
                (v, idx) =>
                  e && (
                    <td key={idx}>
                      {!data.code || (data.code && v.id > 0) ? (
                        <img
                          className="prevent-select"
                          onClick={() => updateCategory(v)}
                          src={v.svg}
                          alt={"logo"}
                          style={{
                            width: 40,
                            transform:
                              data.cat === v.id ? "scale(1.5)" : "scale(1)",
                            opacity: data.cat === v.id ? 1 : 0.25,
                            transition: "all 0.25s",
                          }}
                        />
                      ) : (
                        <div style={{ width: 40, height: 40 }}></div>
                      )}
                    </td>
                  )
              )}
            </tr>
          ))}
        </tbody>
      </table>
      <div
        style={{
          marginTop: 5,
          width: 250,
          backgroundColor: colorsList.lightGrey,
          padding: 5,
          paddingLeft: 10,
          paddingRight: 10,
          borderRadius: 5,
          fontSize: 18,
          textAlign: "center",
        }}
      >
        {data.details}
      </div>
      {data.cat === 0 && (
        <div style={{ marginTop: 10, justifyItems: "center" }}>
          <StdButton
            label={strLang("newAddress")}
            onClick={addAddressModal}
            color={colorsList.green}
            style={{ width: 120 }}
          />
          <div
            style={{
              marginTop: 10,
              backgroundColor: colorsList.lightGrey,
              borderRadius: 5,
              height: 155,
              width: "100%",
              overflow: "auto",
            }}
          >
            {data.addressList.length > 0 &&
              data.addressList.map((e, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: colorsList.lightGreen,
                    margin: 5,
                    padding: 5,
                    borderRadius: 5,
                    // color: colorsList.white,
                  }}
                >
                  <div
                    style={{ flex: 1 }}
                    onClick={() => addAddressModal(index)}
                  >
                    {e.name}
                  </div>
                  <DeleteIcon
                    style={{
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => addAddressModal(index, true)}
                  />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
